/* eslint-disable max-lines */
import React, { ReactElement, useEffect, useMemo, useRef, useState } from 'react';
import { Dimensions, View } from 'react-native';
import { convertStyles } from '@kibt/krn-utils';
import SrcStyles from './index.styl';
import { PageContext, KView, KText, KImage } from '@/component/RtlLayout';
import { $k18n } from '@/common/i18n';
import { useToast } from '@/component/Toast/Toast';
import MyImage from '../MyImage';
import yoda from '@kibt/bridge';
import ShopMessage from '@/assets/icon_detail/shop_message.png';
import { jumpToContactMerchant, jumpToShlef, useJumpToConfirmOrder } from '../../../jump';
import { getBuyShopStatus, postDistributeSelectionAddSelf, Sku, claimSelfMultiBuildCouponToB } from '../../../api';
import {
    logClickBuyNow,
    logClickContact,
    logShowPageErrBar,
    logClickShopIcon,
    onAddCartVisible,
    logClickAddCart,
    logClickShare,
} from '../../../logger2.0';
import { ViewVisible } from '@/component/ViewVisible/ViewVisible';
import { isInApp, isWeb, isIOS, isMobileDeviceValue, PCMaxWidth, AdjustPCStyle } from '@/common/device-info';
import { useExtParamsObject, useGetSellerParams } from '@/page/detail/views/content/utils';
import { showFlashActivity } from '@/page/detail/views/content/utils';
import { postRemindBuyMsg } from '../../../api';
import iconCartBtn from '@/assets/icon_detail/iconAddCart.png';
import { useDetailPageStore } from '@/page/detail/store';
import { logger, radar, webLogger } from '@/common/log';
import BottomAreaTip from '../BottomAreaTip';
import { useDebounceFn, useMemoizedFn } from 'ahooks';
import { afterPv } from '@/common/utils/afterPv';
import { useQuery } from '@/hooks/useQuery';
import { useEntranceType } from '../../const';
import { useCallApp } from '@/common/callApp';
import { ActivityType } from '../BigMarketingBanner/CaculateBlock';
import { useSubsidy } from '../../hooks/useSubsidy';
import { useLockBuyBtn } from '../../hooks/useLockBuyBtn';
import { Toast } from '@kibt/meta-ui-krn';
import { DetailMakeUp } from '../Coudan';
import { useCoudanInfoStore } from '../Coudan/coudanInfoStore';
import { isFixedViewSupport } from '@/component/FixedView';
import { useListenSpecBuy } from '../../hooks/useListenSpecBuy';
import { SHELF_SOURCE_LIST, getShelfObjectFromUrl, refreshShelfMap } from '@/utils/shelfSource';
import { AnimatedRotateSwitch } from '@/component/AnimatedRotateSwitch';
import { useAbStore } from '@/store/useAbStore';
import { KTouchableWithoutFeedback } from '@/component/RtlLayout/Touchable';
import { scaleW } from '@/common/style';
import { AddressAddItemId } from '@/hooks/addressAddItemId';
import { getQuery, SCENE } from '@/common/const';
import { backOrClose } from '@/common/bridge/backOrClose';
import { useLoginStore } from '@/component/LoginSdk/store/useLoginStore';

const Styles = convertStyles(SrcStyles);

let logShowOnlyAddOnce = true;

const showOnlyAdd = (button_type, showCommentLine = false, style) => {
    if (logShowOnlyAddOnce) {
        logShowOnlyAddOnce = false;
        afterPv.then(() => {
            logger.sendShow({
                action: 'ADD_AND_BUY_BUTTON',
                params: {
                    // style 0 加购按钮弱化（线上版本）， 1 加购按钮强化（本期版本）
                    button_type,
                    is_customer_reviews_mode: showCommentLine ? 'TRUE' : 'FALSE',
                    style,
                },
            });
        });
    }
};

type IProps = {
    isPopVisible: boolean; // 规格弹窗是否弹起
    isNotAllImg: boolean;
    showCartStyle: number;
    shopIcon: string;
    shopLogo: string;
    showSpec: (type?) => void;
    addCartItem: any;
    pageActiveStatus: any;
    foldRatio: string;
    addToCartAnimation?: () => void;
    onlyShowAddToCartBtn?: boolean;
    retrievalInfo: Record<any, string>;
};

/**
 * 商详底部操作大组件
 */
const OptionBar = function (props: IProps): ReactElement {
    const {
        isPopVisible,
        isNotAllImg,
        showCartStyle,
        showSpec,
        addCartItem,
        pageActiveStatus,
        foldRatio,
        addToCartAnimation,
        onlyShowAddToCartBtn,
        retrievalInfo,
        shopIcon,
        shopLogo,
    } = props;

    const { showToast, toastNode } = useToast();
    const { callApp } = useCallApp();
    const getStoreState = useDetailPageStore().getState;
    const setStoreState = useDetailPageStore().setState;
    const { version: makeUpVersion } = useCoudanInfoStore(s => s.extraInfo) || {};

    const isToBDetail = useQuery('pageType') === 'seller';
    const clickid = (useQuery('click_id') as string) || '';
    const extParamsStr = useQuery<string>('extParams');
    const extParamsObj = useExtParamsObject();
    const ENTRANCETYPE = useEntranceType();
    const { purchaseQuantity, immediateAvailableQuantity, setAlertVisible, currentSku, pageRawData, refreshCouponList } = useDetailPageStore(s => ({
        purchaseQuantity: s.purchaseQuantity,
        immediateAvailableQuantity: s.immediateAvailableQuantity,
        setAlertVisible: s.setAlertVisible,
        currentSku: s.currentSku as Sku,
        pageRawData: s.pageRawData,
        refreshCouponList: s.refreshCouponList,
    }));

    const showRotateAnimation = useAbStore(s => s?.liveproduct2store)?.value || false;

    const showCommentLine = pageRawData?.comments?.length > 0;
    const showShoppingCart = false; // 外部无需购物车
    const isSendSampleOrder = isToBDetail && useDetailPageStore?.getState()?.showSampleButton; // 1元寄样订单

    // 入驻平台，且通过审核了的商家才展示店铺页入口
    const showShopEntry = pageRawData?.shopControl?.hasShop;

    const { hasSubsidy } = useSubsidy();
    const { lockRef, setLock } = useLockBuyBtn();
    const shelfObject = useRef({});
    useEffect(() => {
        if (isToBDetail) {
            shelfObject.current = getShelfObjectFromUrl();
            refreshShelfMap(shelfObject, SHELF_SOURCE_LIST.ITEM_DETAIL);
        }
    }, []);

    const handleShopClick = () => {
        const merchantId = pageRawData.merchantId;
        logClickShopIcon({
            product_id: pageRawData.itemId,
            shop_id: merchantId,
        });
        return callApp({ pageId: 'ecomm_commodity_detail' });
    };
    const { specBuyUuid } = useListenSpecBuy();
    const { setItem: setItemOfAddressAddItemId } = AddressAddItemId();
    const { jumpToConfirmOrder } = useJumpToConfirmOrder();
    const { sellerMerchantId: sellerMerchantIdFromQuery, sellerUserId: sellerUserIdFromQuery } = useGetSellerParams();
    const onJumpToConfirmOrder = ({
        addressId,
        buyamount,
        merchantId,
        skuId,
        itemId,
        poc,
        needDelay = false,
        backendDispatchUrl,
        toSpecBuy = false,
        specBuyUuid = null,
    }) => {
        if (lockRef.current) {
            webLogger.sendLog({
                type: 'click',
                name: 'dumplicateSubmit',
                value: {
                    page: 'Detail:OptionBar',
                    status: 0,
                    time: Date.now(),
                },
            });
            return;
        }
        webLogger.sendLog({
            type: 'click',
            name: 'dumplicateSubmit',
            value: {
                page: 'Detail:OptionBar',
                status: 1,
                time: Date.now(),
            },
        });
        setLock(true);
        const flashSaleActivityId =
            pageRawData?.activityInfo?.activityId && pageRawData?.activityInfo?.status === 2 && pageRawData?.activityInfo?.saleRate < 100
                ? pageRawData?.activityInfo?.activityId
                : 0;
        const subsidyItem = pageRawData?.activityList?.find(v => v?.marketingActivityType === ActivityType.Exclusive);
        const channelParam = isSendSampleOrder ? { channel: 1 } : {}; // 如果是1元寄样订单， 跳提单页， 新增一个标识
        /** 商业化 clickid  */
        const payload = {
            clickid,
            addressId,
            buyamount,
            merchantId,
            skuId,
            itemId,
            sellerMerchantId: sellerMerchantIdFromQuery,
            sellerUserId: sellerUserIdFromQuery,
            poc,
            needDelay,
            flashSaleActivityId,
            minPurchase: pageRawData.minPurchase,
            retrievalInfo,
            backendDispatchUrl,
            toSpecBuy,
            firstSpecValueId:
                getStoreState().specImageIndex >= 0 ? pageRawData.specs?.[0]?.itemSpecValues?.[getStoreState().specImageIndex].specValueId : '',
            specBuyUuid,
            ...channelParam,
            ...(hasSubsidy && subsidyItem
                ? {
                      promotionId: subsidyItem.activityId,
                      afterDiscountPrice: currentSku?.activityPrice ?? pageRawData.activityPrice,
                  }
                : {}),
            scene: SCENE.PRODUCT_DETAIL_OUTSIDE_WEB, // 端外场景商详 => 提单是固定值
        };

        itemId && setItemOfAddressAddItemId([itemId]);

        jumpToConfirmOrder(payload);
    };

    const goShopServicePage = async () => {
        const merchantId = pageRawData.merchantId;
        const itemId = pageRawData.itemId;
        if (!isInApp) {
            return callApp({ pageId: 'ecomm_commodity_detail' });
        }
        // 未登陆需要登陆, 否则进入客服系统会报错
        const res = await yoda.component.login({});
        if (res?.result !== 1) {
            return;
        }
        try {
            await postRemindBuyMsg({
                merchantId,
                itemId,
            });
        } catch (e) {
            console.log(e, '催单失败');
        }
        logClickContact(pageRawData.itemId);
        jumpToContactMerchant(pageRawData, pageRawData.merchantId, pageRawData.itemId);
    };

    const [shopStatus, setShopStatus] = useState({
        activeStatus: 2, // 上架状态 0 未知/1下架/2上架
        auditStatus: -1, // 商品状态 -1未知，0未提审，2审核通过，3审核未通过且不允许修改，4审核不通过并打回修改
        shopStatus: 1, // 商家状态 1启用，2禁用
        shopBusinessStatus: 1, // 商家营业状态 1营业，2休息
        stock: 0, // 对应sku库存
    });

    const buyNowStatus = async (itemId, skuId) => {
        let flag = true;

        await getBuyShopStatus({
            itemId,
            skuId,
            extParams: extParamsStr,
            sellerUserId: Number(sellerUserIdFromQuery || 0),
            merchantId: Number(sellerMerchantIdFromQuery || 0),
        })
            .then(res => {
                console.log('getBuyShopStatus ', res);
                // context.emit('changLoding', false);
                setShopStatus({
                    activeStatus: res.data.activeStatus,
                    auditStatus: res.data.auditStatus,
                    shopStatus: res.data.shopStatus,
                    shopBusinessStatus: res.data.shopBusinessStatus,
                    stock: res.data.stock,
                });

                if (
                    res.data.shopStatus === 2 ||
                    res.data.shopBusinessStatus === 2 ||
                    res.data.stock <= 0 ||
                    res.data.activeStatus !== 2 ||
                    res.data.auditStatus !== 2
                ) {
                    flag = false;
                    if (res.data.shopBusinessStatus === 1 && res.data.shopStatus === 1) {
                        if (res.data.activeStatus !== 2 && res.data.auditStatus === 2) {
                            showToast({
                                text: $k18n('抱歉，商品已下架'),
                                duration: 3000,
                            });
                        } else if (res.data.activeStatus === 2 && res.data.auditStatus === 2 && res.data.stock <= 0) {
                            showToast({
                                text: $k18n('抱歉，商品已售罄'),
                                duration: 3000,
                            });
                        } else {
                            showToast({
                                text: $k18n('糟糕！商品找不到啦'),
                                duration: 3000,
                            });
                        }
                    } else {
                        showToast({
                            text: $k18n('糟糕！商品找不到啦'),
                            duration: 3000,
                        });
                    }
                }
            })
            .catch(() => {
                // context.emit('changLoding', false);
                flag = false;
                // 走全局的拦截器
                // showToast({
                //     text: err.message,
                //     duration: 3000,
                // });
            });

        return flag;
    };

    const autoGetCoupon = useMemo(() => {
        if (!pageRawData.discountCoupon) return false;
        if (pageRawData?.discountCoupon[0]?.discountFeeType === 3 && pageRawData?.discountCoupon[0]?.couponState === 0) {
            return true;
        } else if (pageRawData.discountCoupon.some(item => item.couponState === 1)) {
            return true;
        } else return false;
    }, [pageRawData]);

    // 商品售罄时购买按钮上方的提示横幅文案
    const getBottomText = useMemo(() => {
        // 秒杀商品整体限购
        if (pageRawData?.activityInfo?.activityId && pageRawData?.activityInfo?.status === 4) {
            return $k18n({ id: 'k_406982', text: '抱歉，您已达活动购买上限，去看看其他商品' });
        }
        // 秒杀商品整体库存为0
        if (pageRawData?.activityInfo?.activityId && showFlashActivity(pageRawData?.activityInfo?.status) && pageRawData?.totalQuantity === 0) {
            return $k18n({ id: 'item_activity_0_stock', text: '抱歉，该商品的活动库存为0' });
        }
        // 普通商品售罄
        return $k18n({ id: 'k_252201', text: '抱歉，商品已售罄' });
    }, [pageRawData]);
    // 当前sku库存小于起购
    const minPurchaseOverLimit = !pageRawData?.extraInfo?.selfOperated && currentSku?.availableQuantity < pageRawData.minPurchase;
    const skuOverActivityLimit = useMemo(() => {
        // 购买数量超出秒杀限购的数量时，购买按钮置灰不可点
        if (
            pageRawData?.activityInfo?.activityId &&
            showFlashActivity(pageRawData?.activityInfo?.status) &&
            pageRawData?.activityInfo?.skuLimitCount?.[currentSku?.skuId] >= 0 &&
            purchaseQuantity > pageRawData?.activityInfo?.skuLimitCount?.[currentSku?.skuId]
        ) {
            return true;
        }
        // 当前sku库存小于起购时
        if (minPurchaseOverLimit) {
            return true;
        }
        return false;
    }, [currentSku]);

    // getInstallmentType: 上报埋点需要
    const getInstallmentType = (() => {
        if (pageRawData?.installmentVO?.installment === 0) return -1;
        else return 0;
    })();
    const addToCart = async (button_type = 2) => {
        logger.sendClick({
            action: 'ADD_AND_BUY_BUTTON',
            params: {
                // button_type 0-仅加购，1-购买, 2 加购&购买
                // click_area button_type 0-加购，1-购买
                button_type,
                click_area: 0,
                is_customer_reviews_mode: showCommentLine ? 'TRUE' : 'FALSE',
                style: pageRawData?.abTest?.bigPromotionButtonWarmUp ? 1 : 0, // 0 加购按钮弱化（线上版本）， 1 加购按钮强化（本期版本）
                is_bubble: useDetailPageStore?.getState()?.hadShowCartBtnTip ? 1 : 0,
            },
        });
        // 加购按钮点击业务埋点
        radar.event({
            name: 'detail_cart_click',
        });
        // // 未登陆需要登陆
        // const res = await yoda.component.login({});
        // if (res?.result !== 1) {
        //     return;
        // }
        if (immediateAvailableQuantity === 0) {
            if (!pageRawData?.extraInfo?.selfOperated) {
                if (pageRawData?.totalQuantity !== 0) {
                    showSpec('cart');
                }
                return;
            }
        }
        // 商品下架，不唤起加购
        if ([1, 20, -1, -10].includes(pageActiveStatus)) {
            // 自营测品
            if (!pageRawData?.extraInfo?.selfOperated) {
                return;
            }
        }
        // 当前sku小于最低起购
        if (minPurchaseOverLimit) {
            if (pageRawData.skus.length > 1) showSpec('cart');
            return;
        }
        let toBuySku;
        if (pageRawData.skus.length === 1) {
            toBuySku = pageRawData.skus[0];
        } else {
            toBuySku = currentSku;
        }
        // 有规格图
        if (!isNotAllImg) {
            if (pageRawData.skus.length > 1) {
                if (pageRawData.specs && pageRawData.specs.length > 1) {
                    logClickAddCart(pageRawData.itemId, toBuySku.skuId, 0, getInstallmentType);
                    showSpec('cart');
                    return;
                }
            }
        }
        // 无规格图
        if (isNotAllImg) {
            if (pageRawData.skus.length > 1) {
                logClickAddCart(pageRawData.itemId, toBuySku.skuId, 0, getInstallmentType);
                showSpec('cart');
                return;
            }
        }
        if (toBuySku && toBuySku.skuId) {
            const { itemId, skuId } = toBuySku;
            const buyamount = purchaseQuantity;
            // 如果是自营测试商品 放开这个校验
            let shopFlag;
            if (pageRawData?.extraInfo?.selfOperated) {
                shopFlag = true;
            } else {
                shopFlag = await buyNowStatus(itemId, skuId);
            }

            if (shopFlag) {
                // 埋点 - 点击直接加购成功
                logClickAddCart(pageRawData.itemId, toBuySku.skuId, 1, getInstallmentType);
                const result = await addCartItem(toBuySku, buyamount, false, true);
                if (result && addToCartAnimation) {
                    addToCartAnimation();
                }
                return true;
            }
            return;
        } else {
            // 埋点 - 点击吊起规格弹窗
            logClickAddCart(pageRawData.itemId, toBuySku.skuId, 0, getInstallmentType);
            showSpec('cart');
        }
    };

    const { isLogin, setLoginModelVisible } = useLoginStore(s => ({
        isLogin: s.isLogin,
        setLoginModelVisible: s.setLoginModelVisible,
    }));

    const buyNow = async (
        button_type = 2,
        options = {
            // 那先加个新字段is_shipping_coupon吧，如果是点了这一期优惠券上报1，否则为0
            is_shipping_coupon: 0,
        }
    ) => {
        const { is_shipping_coupon = 0 } = options || {};
        if (getQuery('from') === 'OrderCnfirmSkuItem') {
            return backOrClose();
        }
        if (lockRef.current) {
            Toast.show({ text: $k18n('您的操作太频繁了') });
            return;
        }
        // 点击下单，不再出现引导弹窗
        setAlertVisible({ ...getStoreState().alertVisible, isClickedBuy: true });
        logger.sendClick({
            action: 'ADD_AND_BUY_BUTTON',
            params: {
                // button_type 0-仅加购，1-购买, 2 加购&购买
                // click_area button_type 0-加购，1-购买
                button_type,
                click_area: 1,
                is_customer_reviews_mode: showCommentLine ? 'TRUE' : 'FALSE',
            },
        });
        // 未登陆需要登陆
        if (!isLogin) {
            return setLoginModelVisible(true);
        }
        // 购买数量超出秒杀限购的数量时，购买按钮置灰不可点
        if (skuOverActivityLimit) {
            Toast.show({ text: $k18n('抱歉，商品已售罄') });
            if (pageRawData.skus.length > 1) showSpec();
            return;
        }
        // 以下是业务校验
        if (immediateAvailableQuantity === 0) {
            if (pageRawData?.totalQuantity !== 0) {
                showSpec();
            }
            return;
        }
        if ([1, 20, -1, -10].includes(pageActiveStatus)) {
            return;
        }

        let toBuySku;
        if (pageRawData.skus.length === 1) {
            toBuySku = pageRawData.skus[0];
        } else {
            toBuySku = currentSku;
        }
        const { merchantId, itemId, skuId, skuSpecDesc } = toBuySku || {};
        const is_with_coupon = pageRawData.discountCoupon?.length > 0 ? 1 : 0; // 是否成功领取
        const coupon_id = pageRawData.discountCoupon?.length > 0 ? `${pageRawData.discountCoupon[0].batchId}` : ''; // 券批次ID

        if (!isNotAllImg) {
            if (pageRawData.skus.length > 1) {
                if (pageRawData.specs && pageRawData.specs.length > 1) {
                    logClickBuyNow(pageRawData.itemId, ENTRANCETYPE, 0, skuSpecDesc, skuId, coupon_id, 0, getInstallmentType, is_shipping_coupon);
                    showSpec();
                    return;
                }
            }
        }
        if (isNotAllImg) {
            if (pageRawData.skus.length > 1) {
                logClickBuyNow(pageRawData.itemId, ENTRANCETYPE, 0, skuSpecDesc, skuId, coupon_id, 0, getInstallmentType, is_shipping_coupon);

                showSpec();
                return;
            }
        }
        if (toBuySku && toBuySku.skuId) {
            const buyamount = purchaseQuantity;
            const addressId = getStoreState().addressInfo?.addressId;
            logClickBuyNow(itemId, ENTRANCETYPE, 1, skuSpecDesc, skuId, coupon_id, 0, getInstallmentType, is_shipping_coupon);
            onJumpToConfirmOrder({
                addressId,
                buyamount,
                merchantId,
                skuId,
                itemId,
                poc: 'buy_3',
                needDelay: false,
                backendDispatchUrl: pageRawData?.pageUrl?.placeOrderJumpUrl,
            });
            return;
        }

        logClickBuyNow(pageRawData.itemId, ENTRANCETYPE, 0, skuSpecDesc, skuId, coupon_id, 0, getInstallmentType, is_shipping_coupon);
        showSpec();
    };

    const onBuyNow = useMemoizedFn(buyNow);
    // 将BuyNow方法挂在到Store上面
    if (!getStoreState().onBuyNow) {
        setStoreState({ onBuyNow });
    }
    const { run: onThrottledBuyNow } = useDebounceFn(
        (button_type = 2) => {
            buyNow(button_type);
        },
        {
            leading: true,
            trailing: false,
            wait: 500,
        }
    );

    const renderOptionBarTip = () => {
        // 如果商品没库存 并且 是自营测试商品的话 不展示提示
        if ([20].includes(pageActiveStatus)) {
            if (pageRawData?.extraInfo?.selfOperated) {
                return null;
            }
        }
        if ([1, 20, -1, -10].includes(pageActiveStatus)) {
            return (
                <KView
                    rtlClassName={'optionBar-tip'}
                    // style={
                    //     isIOS && !isWeb
                    //         ? {
                    //               bottom: 0,
                    //           }
                    //         : {
                    //               bottom: isFixedViewSupport ? 0 : 72,
                    //               // position,
                    //           }
                    // }
                >
                    {pageActiveStatus === -10 ? (
                        <ViewVisible onVisible={() => logShowPageErrBar(2)}>
                            <KText rtlClassName={'optionBar-tip-text'} numberOfLines={2}>
                                {$k18n({ id: 'k_367073', text: '抱歉，该商品在当前地区不支持售卖' })}
                            </KText>
                        </ViewVisible>
                    ) : null}
                    {pageActiveStatus === 1 ? (
                        <ViewVisible onVisible={() => logShowPageErrBar(1)}>
                            <KText rtlClassName={'optionBar-tip-text'}>{$k18n({ id: 'k_252202', text: '抱歉，商品已下架' })}</KText>
                        </ViewVisible>
                    ) : null}
                    {pageActiveStatus === 20 ? (
                        <ViewVisible onVisible={() => logShowPageErrBar(0)}>
                            <KText rtlClassName={'optionBar-tip-text'}>{getBottomText}</KText>
                        </ViewVisible>
                    ) : null}
                    {pageActiveStatus === -1 ? (
                        <ViewVisible onVisible={() => logShowPageErrBar(1)}>
                            <KText rtlClassName={'optionBar-tip-text'}>{$k18n({ id: 'k_252202', text: '抱歉，商品已下架' })}</KText>
                        </ViewVisible>
                    ) : null}
                </KView>
            );
        }
    };

    const renderBtnBox = () => {
        // 自营测品
        const renderSelfOperated = (
            <KTouchableWithoutFeedback style={{"flexGrow":1,"flex":1}} onPress={() => addToCart()}>
                <KView rtlClassName={['buyBtnWrapper', [1, -1, -10].includes(pageActiveStatus) ? 'disabledBtn' : '']}>
                    <KView rtlClassName={['buyBtn']}>
                        <KText rtlClassName={['buyBtnText']}>{$k18n({ id: 'add_to_cart', text: '加入购物车' })}</KText>
                        <ViewVisible onVisible={() => onAddCartVisible()} />
                    </KView>
                </KView>
            </KTouchableWithoutFeedback>
        );

        // 加购弱化样式实验
        const renderOldShopCartStyle =
            showCartStyle === 0 ? (
                <KTouchableWithoutFeedback style={{"flexGrow":1,"flex":1}} onPress={() => addToCart()}>
                    <KView
                        rtlClassName={[
                            'cartBtnWrapper2',
                            (pageRawData?.totalQuantity === 0 && immediateAvailableQuantity === 0) ||
                            [1, 20, -1, -10].includes(pageActiveStatus) ||
                            minPurchaseOverLimit
                                ? 'disabledBtn'
                                : '',
                        ]}>
                        <KView rtlClassName={['buyBtn']}>
                            <KText rtlClassName={['buyBtnText', 'cartBtnText']}>{$k18n({ id: 'add_to_cart', text: '加入购物车' })}</KText>
                            <ViewVisible onVisible={() => onAddCartVisible()} />
                        </KView>
                    </KView>
                </KTouchableWithoutFeedback>
            ) : (
                <KTouchableWithoutFeedback style={{"flexGrow":1,"flex":1}} onPress={() => addToCart()}>
                    <KView
                        rtlClassName={[
                            'cartBtnWrapperWeak',
                            (pageRawData?.totalQuantity === 0 && immediateAvailableQuantity === 0) ||
                            [1, 20, -1].includes(pageActiveStatus) ||
                            minPurchaseOverLimit
                                ? 'disabledBtn'
                                : '',
                        ]}>
                        <KView rtlClassName={['buyBtnWeak']}>
                            <ViewVisible onVisible={() => onAddCartVisible()} />
                            <KImage rtlClassName={['addCartIcon']} source={iconCartBtn} />
                        </KView>
                    </KView>
                </KTouchableWithoutFeedback>
            );

        const renderBuyBtnTextView = type => {
            const textMap = {
                1: $k18n({ id: 'k_332847', text: '领券购买' }),
                2: $k18n({ id: 'k_226119', text: '立刻购买' }),
            };

            return (
                <KView>
                    <KText rtlClassName={['buyBtnText', showShoppingCart && !isToBDetail && 'buyBtnTextSmall']}>{textMap[type] || textMap[2]}</KText>
                    {pageRawData?.lotteryInfo?.buttonText && !pageRawData?.abTest?.bigPromotionButtonWarmUp ? (
                        <KText
                            rtlClassName={['buyBtnText', showShoppingCart && !isToBDetail && 'buyBtnTextSmall']}
                            style={{"fontSize":"2.6570048309178746rem"}}>
                            {pageRawData?.lotteryInfo?.buttonText}
                        </KText>
                    ) : null}
                </KView>
            );
        };

        return (
            <KView rtlClassName={['btn-box']}>
                {(onlyShowAddToCartBtn ||
                    (pageRawData.abTest?.addCartOnly &&
                        pageRawData.shippingFeeView &&
                        pageRawData.shippingFeeView?.threshold &&
                        ((!currentSku.skuId && pageRawData.shippingFeeView?.threshold > pageRawData.activityPrice * purchaseQuantity) ||
                            (currentSku.skuId && pageRawData.shippingFeeView?.threshold > currentSku.activityPrice * purchaseQuantity)))) &&
                showShoppingCart ? (
                    <>
                        <KTouchableWithoutFeedback
                            style={{"flexGrow":1,"flex":1}}
                            onPress={() => {
                                addToCart(0);
                            }}>
                            <KView
                                rtlClassName={[
                                    'buyBtnWrapper',
                                    (!pageRawData?.extraInfo?.selfOperated &&
                                        ((pageRawData?.totalQuantity === 0 && immediateAvailableQuantity === 0) ||
                                            [1, 20, -1, -10].includes(pageActiveStatus))) ||
                                    minPurchaseOverLimit
                                        ? 'disabledBtn'
                                        : '',
                                ]}>
                                <ViewVisible
                                    onVisible={() => {
                                        onAddCartVisible();
                                        showOnlyAdd(0, showCommentLine, pageRawData?.abTest?.bigPromotionButtonWarmUp ? 1 : 0);
                                    }}>
                                    <KView rtlClassName={['buyBtn']}>
                                        <KText rtlClassName={['buyBtnText']}>{$k18n({ id: 'add_to_cart', text: '加入购物车' })}</KText>
                                    </KView>
                                </ViewVisible>
                            </KView>
                        </KTouchableWithoutFeedback>
                    </>
                ) : (
                    <>
                        {/* 05-10 产品需求 符合条件 隐藏底部加购 */}
                        {showShoppingCart && !isToBDetail && !pageRawData?.extraInfo?.hideAddCart
                            ? pageRawData?.extraInfo?.selfOperated && showShoppingCart
                                ? renderSelfOperated
                                : renderOldShopCartStyle
                            : null}
                        {pageRawData?.extraInfo?.selfOperated && showShoppingCart ? null : (
                            <KTouchableWithoutFeedback
                                style={{"flexGrow":1,"flex":1}}
                                onPress={() => {
                                    // 购买按钮点击业务埋点
                                    radar.event({
                                        name: 'detail_buy_click',
                                    });
                                    onThrottledBuyNow();
                                }}>
                                <KView
                                    rtlClassName={[
                                        'buyBtnWrapper',
                                        showShoppingCart && !isToBDetail && showCartStyle === 1 ? 'buyBtnWrapperWhenWeak' : '',
                                        (pageRawData?.totalQuantity === 0 && immediateAvailableQuantity === 0) ||
                                        [1, 20, -1, -10].includes(pageActiveStatus) ||
                                        skuOverActivityLimit
                                            ? 'disabledBtn'
                                            : '',
                                    ]}>
                                    <ViewVisible
                                        onVisible={() => showOnlyAdd(2, showCommentLine, pageRawData?.abTest?.bigPromotionButtonWarmUp ? 1 : 0)}>
                                        <KView rtlClassName={['buyBtn']}>{autoGetCoupon ? renderBuyBtnTextView(1) : renderBuyBtnTextView(2)}</KView>
                                    </ViewVisible>
                                </KView>
                            </KTouchableWithoutFeedback>
                        )}
                    </>
                )}
            </KView>
        );
    };

    return (
        <PageContext.Provider value={{ Styles }}>
            <div style={{ position: 'fixed', bottom: 'env(safe-area-inset-bottom)', left: 0, zIndex: 10, ...AdjustPCStyle }}>
                <KView style={{"backgroundColor":"white","paddingBottom":"1.9323671497584543rem"}}>
                    {renderOptionBarTip()}
                    <KView rtlClassName={'optionBar'}>
                        <View style={{"width":"100%"}}>
                            {/* 底部按钮上方的提示文案 */}
                            {makeUpVersion === 2 && !isToBDetail ? (
                                <DetailMakeUp />
                            ) : !isToBDetail && !isPopVisible && ![1, 20, -1, -10].includes(pageActiveStatus) ? (
                                <BottomAreaTip
                                    {...{
                                        pageRawData,
                                        isFrom: 'detail',
                                        showCouponMakeUpTip: onlyShowAddToCartBtn,
                                    }}
                                />
                            ) : null}
                            <KView rtlClassName={'btnWrap'}>
                                {showShopEntry && !isToBDetail ? (
                                    <KTouchableWithoutFeedback onPress={handleShopClick}>
                                        <KView rtlClassName={'merchantWrap'}>
                                            {/* <Image rtlClassName={'merchantIcon'} source={{ uri: shopIcon }} /> */}
                                            {showRotateAnimation && !isWeb ? (
                                                <AnimatedRotateSwitch style={{"width":"6.521739130434783rem","height":"6.521739130434783rem","marginBottom":"0.48309178743961356rem"}} duration={160} delay={2000}>
                                                    <KImage
                                                        style={{"width":"6.521739130434783rem","height":"6.521739130434783rem"}}
                                                        source={{
                                                            uri: 'https://aws-static.kwai.net/udata/pkg/proweb/shop/c/kibt_ecommerce_c_shop.52300f987d34fce9.png',
                                                        }}
                                                    />
                                                    <KImage
                                                        style={{"width":"6.521739130434783rem","height":"6.521739130434783rem","borderRadius":"3.381642512077295rem"}}
                                                        source={{
                                                            uri: shopLogo,
                                                        }}
                                                    />
                                                </AnimatedRotateSwitch>
                                            ) : (
                                                <KImage
                                                    style={{"width":"6.521739130434783rem","height":"6.521739130434783rem"}}
                                                    rtlClassName={'merchantIcon'}
                                                    source={{
                                                        uri: 'https://aws-static.kwai.net/udata/pkg/proweb/shop/c/kibt_ecommerce_c_shop.52300f987d34fce9.png',
                                                    }}
                                                />
                                            )}
                                            <KView rtlClassName={'erchantView'}>
                                                <KText rtlClassName={'erchantText'}>{$k18n({ id: 'k_252262', text: '店铺' })}</KText>
                                            </KView>
                                        </KView>
                                    </KTouchableWithoutFeedback>
                                ) : null}
                                {!isToBDetail && (
                                    <KTouchableWithoutFeedback onPress={() => goShopServicePage()}>
                                        <KView rtlClassName={'contactShopService'}>
                                            <KView rtlClassName={''}>
                                                <MyImage imageSrc={ShopMessage} styleObj={{ width: 32, height: 32 }} />
                                            </KView>
                                            <KText rtlClassName={'contactShopServiceText'}>{$k18n('联系')}</KText>
                                        </KView>
                                    </KTouchableWithoutFeedback>
                                )}
                                {renderBtnBox()}
                            </KView>
                        </View>
                    </KView>
                </KView>
            </div>
            {toastNode}
        </PageContext.Provider>
    );
};

export default OptionBar;
